/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IButtonStyles } from '@fluentui/react/lib/Button';
import { ITheme } from '@fluentui/react/lib/Styling';
import { Theme } from '../../../common/enums/Theme';
import { FontSizes } from '../../../styles/teams';
import { ContrastColors } from '../../../styles/teams/TeamsColors';
import { TemplateIconStyles } from '../../common/TemplateIcon';

export const getButtonStyles = (theme: ITheme, themeName: Theme): Partial<IButtonStyles> => {
    const borderHoverColor = themeName === Theme.Contrast ? ContrastColors.appBrand06 : theme.palette.neutralTertiary;
    const borderfocusColor = themeName === Theme.Contrast ? ContrastColors.appBrand06 : theme.palette.neutralQuaternary;
    return {
        root: {
            padding: '0.875rem',
            borderRadius: '3px',
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
            borderWidth: '1px',
            borderStyle: 'solid',
            selectors: {
                '&:hover': {
                    background: theme.palette.neutralLight,
                },
                '.template-icon-title': {
                    textAlign: 'initial',
                },
            },
            backgroundColor: theme.palette.white,
            borderColor: theme.palette.neutralTertiaryAlt,
            height: '5.25rem',
        },
        flexContainer: {
            justifyContent: 'initial',
        },
        rootHovered: {
            backgroundColor: theme.palette.neutralLighterAlt,
            borderColor: borderHoverColor,
        },
        rootFocused: {
            backgroundColor: theme.palette.white,
            borderColor: borderfocusColor,
            selectors: {
                '::after': {
                    outline: `1px solid ${theme.palette.black} !important`,
                },
            },
        },
        rootPressed: {
            backgroundColor: theme.palette.neutralQuaternary,
            borderColor: borderHoverColor,
        },
        rootChecked: {
            backgroundColor: theme.palette.neutralTertiaryAlt,
            borderColor: borderHoverColor,
        },
        rootDisabled: {
            backgroundColor: theme.palette.neutralLight,
            borderColor: theme.palette.neutralQuaternary,
        },
    };
};

export const getIconStyles = (): Partial<TemplateIconStyles> => {
    return {
        iconContainer: {
            width: '3.5rem',
            height: '3.5rem',
            marginRight: '1.25rem',
        },
        icon: {
            width: '1.75rem',
            height: '1.75rem',
            fontSize: FontSizes.size28,
        },
    };
};
